import styled from 'styled-components';
import { Table as AntTable } from 'antd';
import colors from '../../../utils/colors';

export const StyledAntTable = styled(AntTable)`
  td {
    color: ${colors.darkGray};
    font-size: 13px;
    font-weight: 600;
    line-height: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 8px 16px !important;
    height: 50px;
  }

  .ant-table-pagination.ant-pagination {
    padding-right: 24px;
  }
`;
